module.exports = __webpack_public_path__ + "MaterialIcons-Regular.012cf6a10129e2275d79.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/material-icon/MaterialIcons-Regular.woff
// module id = ../../../../../src/assets/material-icon/MaterialIcons-Regular.woff
// module chunks = styles